import { createEvent } from 'effector'
import { SelectedPurchaseOption } from './types'

type OpenCasePageProps = {
  id: number
  type: number
  name: string
  description: string
  onPrewiew: boolean
}

export const openCasePage = createEvent<OpenCasePageProps>()
export const setCaseId = createEvent<number>()
export const setOpenedLbKind = createEvent<boolean>()
export const setSelectedPurchaseCurrency = createEvent<SelectedPurchaseOption>()
export const triggerKeysRefetch = createEvent<string>()
